<template>
    <b-modal
        size="lg"
        title="Delete Survey"
        ref="DeleteSurvey"
        @hidden="closeModal"
        centered>
        <div id="delete-survey" class="modal-form text-center py-4">
            Are you sure you want to delete <span class="text-primary">{{ survey_modal.delete.title }}</span>?
        </div>
        <div slot="modal-footer">
            <b-button
                variant="ghost"
                class="btn-cancel"
                style="margin-right: .25rem;"
                @click="closeModal">
                Cancel
            </b-button>
            <b-button
                variant="primary"
                style="margin-left: .25rem;"
                @click="deleteSurvey(survey_modal.delete.uuid)">
                Delete
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "DeleteSurvey",
    props: ["open"],
    computed: {
        ...mapState("engagementSurvey", ["survey_modal", "param"])
    },
    methods: {
        closeModal: function() {
            this.$store.commit("engagementSurvey/setModal", {
                type: "delete",
                status: false,
                id: null,
                title: null
            });
        },

        deleteSurvey: async function() {
            let id = this.survey_modal.delete.id;
            await this.$store.dispatch("engagementSurvey/delete", id)
                .then(async () => {
                    await this.$store.dispatch("engagementSurvey/getList", this.param);
                });
        }
    },
    watch: {
        open: function(value) {
            if(value === true) {
                this.$refs.DeleteSurvey.show();
            } else {
                this.$refs.DeleteSurvey.hide();
            }
        }
    }
}
</script>
